$(document).ready(function () {
	// Header-new & Nav + responsive
	$('.desktop-nav li').click(function () {
		$(this).addClass('active')
		$(this).parent().children('li').not(this).removeClass('active')
	})

	$('.mobile-nav-icon').click(function () {
		$('.header-new__mob-nav__holder').css('display', 'flex')
	})

	$('.header-new__mobile-close').click(function () {
		$('.header-new__mob-nav__holder').hide()
	})

	$('.header-new__mobile-logo a').click(function () {
		$('.header-new__mob-nav__holder').hide()
	})

	$('.header-new__mob-nav__holder li').click(function () {
		$('.header-new__mob-nav__holder').hide()
	})

	// Locality columns
	$(function () {
		var maxItems = 5
		var activeClass = 'is-active'

		$('.hp-search__localities-holder .locality').each(function () {
			var $locality = $(this)
			var $items = $locality.find('ul li')
			var $toggle = $locality.find('.hp-search__localities-all')

			$toggle.data('label', $toggle.text())

			if ($items.length > maxItems) {
				$items.slice(maxItems).hide()
			} else {
				$toggle.hide()
			}
		})

		$('.hp-search__localities-holder').on('click', '.hp-search__localities-all', function (e) {
			e.preventDefault()

			var $link = $(this)
			var $locality = $link.closest('.locality')
			var $items = $locality.find('ul li')
			var $localityAll = $locality.find('.locality-all')
			var isExpanded = $link.data('expanded') === true

			if (isExpanded) {
				$items.slice(maxItems).slideUp()
				$link.data('expanded', false).text($link.data('label'))
				$localityAll.removeClass(activeClass)
			} else {
				$items.slice(maxItems).slideDown()
				$link.data('expanded', true).text('Skrýt <')
				$localityAll.addClass(activeClass)
			}
		})
	})

	// Search tabs
	$(function () {
		$('.tabs').each(function () {
			const $tabs = $(this)

			$tabs.find('.tabs__chip').on('click', function () {
				const $chip = $(this)
				const targetTab = $chip.data('tab')

				$tabs.find('.tabs__chip').removeClass('is-active')
				$chip.addClass('is-active')

				$tabs.find('.tabs__panel').removeClass('is-active')
				$tabs.find('.tabs__panel[data-tab="' + targetTab + '"]').addClass('is-active')
			})
		})
	})

	// Reaction slider
	$('.reactions__slider').slick({
		centerMode: true,
		slidesToShow: 3,
		autoplaySpeed: 4000,
		arrows: true,
		prevArrow: $('.reactions-arrow--prev'),
		nextArrow: $('.reactions-arrow--next'),
		responsive: [
			{
				breakpoint: 575,
				settings: {
					centerPadding: '10px',
					slidesToShow: 1,
				},
			},
		],
	})

	// Profile slider
	$('.profile__slider').slick({
		centerMode: true,
		centerPadding: '60px',
		slidesToShow: 1,
		prevArrow: $('.profile-arrow--prev'),
		nextArrow: $('.profile-arrow--next'),
		arrows: true,
		responsive: [
			{
				breakpoint: 575,
				settings: {
					centerPadding: '10px',
					slidesToShow: 1,
				},
			},
		],
	})

	// Article slider
	$('.hp-article__slider').slick({
		centerMode: true,
		slidesToShow: 3,
		// autoplay: true,
		autoplaySpeed: 4000,
		arrows: true,
		prevArrow: $('.article-arrow--prev'),
		nextArrow: $('.article-arrow--next'),
		responsive: [
			{
				breakpoint: 575,
				settings: {
					centerPadding: '10px',
					slidesToShow: 1,
				},
			},
		],
	})

	/* ==========================================================================
	  CHATBOT
==========================================================================  */

	$(function () {
		const $widget = $('#chat-widget')
		const $form = $('#chat-form')
		const $input = $('#chat-input-text')
		const $messages = $('#chat-messages')
		const $title = $('#chat-title')
		const $reset = $('#chat-reset')
		const $sublabelParent = $('.chat-card__sublabel')
		const $sublabel = $('.chat-card__sublabel span')

		let hasStarted = false

		$reset.hide()

		$input.on('input', function () {
			this.style.height = 'auto'
			this.style.height = this.scrollHeight + 'px'
		})

		$input.on('input', function () {
			if ($(this).val().trim().length > 0) {
				$sublabelParent.addClass('is-active')
				$sublabel.addClass('is-visible')
			} else {
				$sublabelParent.removeClass('is-active')
				$sublabel.removeClass('is-visible')
			}
		})

		// Bez HTML stringů kvůli Trusted Types: renderujeme DOMem
		const botReplies = [
			{
				text: 'Díky za dotaz, našel jsem pro tebe pár možností.',
				linkText: 'Otevřít odkaz',
				href: 'https://fajn-brigady.cz',
			},
			{
				text: 'To zní zajímavě, tady je první návrh řešení.',
				linkText: 'Zde je odkaz',
				href: 'https://fajn-brigady.cz',
			},
			{
				text: 'Podle tvé otázky bych se podíval na tuto stránku.',
				linkText: 'Podívej se sem',
				href: 'https://fajn-brigady.cz',
			},
			{
				text: 'Připravil jsem pro tebe krátkou odpověď.',
				linkText: 'Zobrazit detail',
				href: 'https://fajn-brigady.cz',
			},
		]

		function appendMessage(text, type) {
			const isBot = type === 'bot'

			const $message = $('<div>')
				.addClass('message')
				.addClass(isBot ? 'message--bot' : 'message--user')

			const $bubble = $('<div>').addClass('message__bubble')

			// User message vždy jako text
			$bubble.text(String(text))

			$message.append($bubble)
			$messages.append($message)
			$messages.scrollTop($messages[0].scrollHeight)
			return $message
		}

		function appendBotMessage(replyObj) {
			const $message = $('<div>').addClass('message message--bot')
			const $bubble = $('<div>').addClass('message__bubble')

			// Text
			$bubble.append(document.createTextNode(String(replyObj.text || '')))

			// Link (bez innerHTML)
			if (replyObj && replyObj.href && replyObj.linkText) {
				$bubble.append($('<br>'))

				const $a = $('<a>')
					.attr('href', replyObj.href)
					.attr('target', '_blank')
					.attr('rel', 'noopener noreferrer')
					.text(String(replyObj.linkText))

				$bubble.append($a)
			}

			$message.append($bubble)
			$messages.append($message)
			$messages.scrollTop($messages[0].scrollHeight)
			return $message
		}

		function appendTypingMessage() {
			const $typing = $('<div>').addClass('message message--bot message--typing')
			const $bubble = $('<div>').addClass('message__bubble')
			const $typingEl = $('<div>').addClass('typing')

			$typingEl.append($('<span>'), $('<span>'), $('<span>'))
			$bubble.append($typingEl)
			$typing.append($bubble)

			$messages.append($typing)
			$messages.scrollTop($messages[0].scrollHeight)
			return $typing
		}

		$form.on('submit', function (e) {
			e.preventDefault()

			const text = $input.val().trim()
			if (!text) return

			if (!hasStarted) {
				hasStarted = true
				$widget.removeClass('chat-widget--collapsed')
				$title.text(text)
				$('.chat-input__avatar').hide()
				$('.chat-header__title').addClass('chat-started')
				$('.chat-input__field').addClass('chat-input__field--smaller').attr('placeholder', 'Vaše otázka')
				$('.chat-input__button').text('Zeptat se')
				$('.chat-input__inner').addClass('chat-input__inner--smaller')
				$reset.fadeIn(150)
			}

			appendMessage(text, 'user')

			$input.val('')
			$input.css('height', 'auto')

			const reply = botReplies[Math.floor(Math.random() * botReplies.length)]

			const $typing = appendTypingMessage()

			setTimeout(function () {
				$typing.remove()
				appendBotMessage(reply)
			}, 800)
		})

		$reset.on('click', function () {
			$messages.empty()
			$widget.addClass('chat-widget--collapsed')
			$title.text('Vaše otázka')
			hasStarted = false

			$('.chat-input__avatar').show()
			$('.chat-header__title').removeClass('chat-started')
			$('.chat-input__field').removeClass('chat-input__field--smaller')
			$('.chat-input__inner').removeClass('chat-input__inner--smaller')
			$('.chat-input__button').text('Najít')

			$input.val('')
			$input.css('height', 'auto')

			$reset.hide()
			$('html, body').animate(
				{
					scrollTop: $('#hp-search__title').offset().top,
				},
				500,
			)
		})
	})

	// Firmy
	$('.reference__slider').bxSlider({
		pager: false,
		infiniteLoop: true,
		minSlides: 1,
		auto: false,
		maxSlides: 2,
		moveSlides: 1,
		slideWidth: 436,
		slideMargin: 12,
		pause: 3500,
		hideControlOnEnd: true,
		nextText: '<img src="images/angle-blue.svg" width="60" height="60"/>',
		prevText: '<img class="rotate-me" src="images/angle-blue.svg" width="60" height="60"/>',
	})

	function animateCount($el) {
		const target = parseInt($el.data('to'), 10) || 0
		const duration = 2000

		$({ count: 0 }).animate(
			{ count: target },
			{
				duration,
				easing: 'swing',
				step: function (now) {
					$el.text(Math.floor(now))
				},
				complete: function () {
					$el.text(target)
				},
			},
		)
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect()
		return rect.top < window.innerHeight && rect.bottom >= 0
	}

	function checkCounters() {
		$('.counter').each(function () {
			const $el = $(this)
			if (!$el.data('started') && isInViewport(this)) {
				$el.data('started', true)
				animateCount($el)
			}
		})
	}

	$(window).on('scroll resize load', checkCounters)
	checkCounters()

	// Ride
	$('.ride__slider').bxSlider({
		pager: false,
		infiniteLoop: true,
		minSlides: 1,
		auto: false,
		maxSlides: 1,
		moveSlides: 1,
		pause: 3500,
		hideControlOnEnd: true,
		nextText: '<img src="images/angle-blue.svg" width="60" height="60"/>',
		prevText: '<img class="rotate-me" src="images/angle-blue.svg" width="60" height="60"/>',
	})

	$('.partners__slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: $('.profile-arrow--prev'),
		nextArrow: $('.profile-arrow--next'),
		autoplay: false,
		autoplaySpeed: 3000,
		infinite: true,
		responsive: [
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 1190,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	})

	const HEADER_HEIGHT = 80

	$('a[href^="#"]').on('click', function (e) {
		const target = $(this.getAttribute('href'))

		if (target.length) {
			e.preventDefault()

			$('html, body').animate(
				{
					scrollTop: target.offset().top - HEADER_HEIGHT,
				},
				1200,
			)
		}
	})

	AOS.init({
		once: true,
		duration: 800,
	})
})